module.exports = __webpack_public_path__ + "static/media/textos.c7caa595.png";